module.exports = __webpack_public_path__ + "img/fondo-login-logo-dinapsis.0ebf7cb2.svg";